export const smsReminderTemplate = "Hello {{.PatientFirstname}}! This is a reminder of your upcoming appointment on {{.AppointmentDate}} at {{.AppointmentTime}} . Please call us at {{.OfficePhone}} if you have any questions. We look forward to seeing you soon.";
export const smsReviewTemplate = "Hello {{.PatientFirstname}}! Thank you for visiting us on {{.AppointmentDate}}. We hope you had a great experience. Your feedback is important to us! Please take a moment to leave us a review and let us know how we did: {{.ReviewLink}} \n" +
  "\n" +
  "Thank you for your time—we appreciate your input and look forward to seeing you again!";
export const smsSaveTheDateTemplate = "Hello {{.PatientFirstname}}! Your appointment has been scheduled for {{.AppointmentDate}} at {{.AppointmentTime}} with {{.Providers}}. Please call us at {{.OfficePhone}} if you have any questions. We look forward to seeing you!";

export const dataTemplate = {
  content: null,
  html: "",
  status: "draft",
  name: "",
  subject: "",
  active: false,
  template_data: null,
  template: {
    sms: {
      template: "",
      opt_out: "",
    },
    email: {
      html_template_url: "",
      json_template_url: "",
      template_type: "builder-template",
    },
    phone: {
      introduction_message: {
        type: "",
        text: "",
        audio: "",
      },
      appointment_prototype_message: {
        type: "",
        text: "",
        audio: "",
      },
      ai_transfer_message: {
        type: "",
        text: "",
        audio: "",
      },
      human_pickup_message: {
        type: "",
        text: "",
        audio: "",
      },
      voice_mail_pickup_message: {
        type: "",
        text: "",
        audio: "",
      },
      on_opt_out_response: {
        type: "",
        text: "",
        audio: "",
      },
      on_confirmation_response: {
        type: "",
        text: "",
        audio: "",
      },
      call_context: {
        type: "",
        text: "",
      },
    },
  },
  settings: {
    text_reduction: "",
    opt_out_reduction: false,
    call_reduction: false,
    overlap_protection: false,
    include_confirmation_link_in_sms: false,
    send_to_confirmed: false,
    sending_date: {
      fixed_time: null,
      days_since_the_event: {
        send_time: null,
        days: null,
      },
      hours_since_the_event: null,
      fixed_date: null,
      previous_day: {
        send_time: null,
        days_before: null,
      },
      same_day: {
        hours_before: null,
        send_after_time: null,
        enabled: false,
      },
    },
    phone_type: {
      home: false,
      cell: false,
      work: false,
    },
    callback_times_if_no_pickup: false,
    reactivation:{
      days_since_last_appointment: null,
      recurrence: null
    },
    filter: {
      exclude_appointments_before_time: null,
      exclude_if_has_sameday_appointments: false,
      scheduled_appointments_type: "",
      providers: { is_included: true, list: [] },
      appointment_type: { is_included: true, list: [] },
      treatment_codes: { is_included: true, list: [] },
      patient_ids: { is_included: true, list: [] },
      patient_status: "active",
      age_range: [],
      last_visit_range: [],
      exclude_patients_with_future_appointments: false,
      zip_codes: [],
      exclude_duplicate_patients: false,
      move_weekend: "0",
      send_right_away: false,
      exclude_weekdays: [],
      oral_health_score_range: [],
      outstanding_treatment_categories: [],
    },
    nps: null,
    ai_enabled: false,
  },
};

export const placeholders = [
  { placeholder: "{{.PatientFirstname}}", meaning: "Patient Firstname" },
  { placeholder: "{{.PatientLastname}}", meaning: "Patient Lastname" },
  { placeholder: "{{.OfficeName}}", meaning: "Office Name" },
  { placeholder: "{{.OfficePhone}}", meaning: "Office Phone" },
  { placeholder: "{{.OfficeAddress1}}", meaning: "Office Address Line 1" },
  { placeholder: "{{.OfficeAddress2}}", meaning: "Office Address Line 2" },
  { placeholder: "{{.OfficeCity}}", meaning: "Office City" },
  { placeholder: "{{.OfficeState}}", meaning: "Office State" },
  { placeholder: "{{.OfficeZip}}", meaning: "Office Zip" },
  { placeholder: "{{.AppointmentDate}}", meaning: "Appointment Date" },
  { placeholder: "{{.AppointmentDay}}", meaning: "Appointment Day" },
  { placeholder: "{{.AppointmentTime}}", meaning: "Appointment Time" },
  { placeholder: "{{.WebsiteURL}}", meaning: "Website URL" },
  { placeholder: "{{.PrivacyPolicy}}", meaning: "Privacy Policy" },
  { placeholder: "{{.BusinessWebsiteURL}}", meaning: "Business Website URL" },
  { placeholder: "{{.OfficeDirections}}", meaning: "Office Directions" },
  { placeholder: "{{.ContactUsEmail}}", meaning: "Contact Us Email" },
  { placeholder: "{{.AlternativePhone}}", meaning: "Alternative Phone" },
  { placeholder: "{{.ExtraPlaceholder}}", meaning: "Extra Placeholder" },
  { placeholder: "{{.LandingURL}}", meaning: "Landing URL" },
  { placeholder: "{{.Providers}}", meaning: "Providers" },
  { placeholder: "{{.OptoutLink}}", meaning: "Optout Link" },
  { placeholder: "{{.ConfirmationLink}}", meaning: "Confirmation Link" },
  { placeholder: "{{.GroupAppointments}}", meaning: "Group Appointments" },
  { placeholder: "{{.GroupConfirmationLink}}", meaning: "Group Confirmation Link" },
  { placeholder: "{{.FacebookLink}}", meaning: "Facebook Review Link" },
  { placeholder: "{{.GoogleLink}}", meaning: "Google Review Link" },
  { placeholder: "{{.HealthGradesLink}}", meaning: "Health Grades Link" },
  { placeholder: "{{.RateMdsLink}}", meaning: "RateMds Review Link" },
  { placeholder: "{{.VitalsLink}}", meaning: "Vitals Review Link" },
  { placeholder: "{{.YelpLink}}", meaning: "Yelp Review Link" },
  { placeholder: "{{.ReviewLink}}", meaning: "Review Link" },
  { placeholder: "{{.AdService}}", meaning: "Service (detected from Facebook ad)" },
  { placeholder: "{{.PatientEmail}}", meaning: "Patient Email" },
  { placeholder: "{{.FacebookCampaignName}}", meaning: "Facebook Campaign Name" },
];

const allPlaceholders = [
  '{{.PatientFirstname}}',
  '{{.OfficeName}}',
  '{{.OfficePhone}}',
  '{{.OfficeAddress1}}',
  '{{.OfficeAddress2}}',
  '{{.OfficeCity}}',
  '{{.OfficeState}}',
  '{{.OfficeZip}}',
  '{{.WebsiteURL}}',
  '{{.PrivacyPolicy}}',
  '{{.BusinessWebsiteURL}}',
  '{{.OfficeDirections}}',
  '{{.ContactUsEmail}}',
  '{{.AlternativePhone}}',
  '{{.ExtraPlaceholder}}',
  '{{.LandingURL}}',
  '{{.OptoutLink}}'
];
const reminderPlaceholders = [
  '{{.AppointmentDate}}',
  '{{.AppointmentDay}}',
  '{{.AppointmentTime}}',
  '{{.Providers}}',
  '{{.ConfirmationLink}}',
  '{{.GroupAppointments}}',
  '{{.GroupConfirmationLink}}'
];
const reviewPlaceholders = [
  // '{{.FacebookLink}}',
  // '{{.GoogleLink}}',
  // '{{.HealthGradesLink}}',
  // '{{.RateMdsLink}}',
  // '{{.VitalsLink}}',
  // '{{.YelpLink}}',
  '{{.ReviewLink}}',
  '{{.AppointmentDate}}',
  '{{.AppointmentDay}}',
  '{{.AppointmentTime}}',
  '{{.Providers}}'
];

export const getCampaignPlaceholders = (campaignType) => {
  const campaignPlaceholders = [...allPlaceholders];
  if (campaignType === 'reminder' || campaignType === 'confirmation') {
    campaignPlaceholders.push(...reminderPlaceholders);
  } else if (campaignType === 'review') {
    campaignPlaceholders.push(...reviewPlaceholders);
  } else if (campaignType === 'lead-ads') {
    // Lead-ads only supports placeholders the drip worker can render
    return placeholders.filter(item => [
      '{{.PatientFirstname}}',
      '{{.PatientLastname}}',
      '{{.OfficeName}}',
      '{{.OfficePhone}}',
      '{{.OfficeAddress1}}',
      '{{.OfficeAddress2}}',
      '{{.OfficeCity}}',
      '{{.OfficeState}}',
      '{{.OfficeZip}}',
      '{{.WebsiteURL}}',
      '{{.PrivacyPolicy}}',
      '{{.BusinessWebsiteURL}}',
      '{{.OfficeDirections}}',
      '{{.ContactUsEmail}}',
      '{{.AlternativePhone}}',
      '{{.LandingURL}}',
      '{{.Providers}}',
      '{{.OptoutLink}}',
      '{{.AdService}}',
      '{{.PatientEmail}}',
      '{{.FacebookCampaignName}}',
    ].includes(item.placeholder));
  }
  return placeholders.filter(item =>
    campaignPlaceholders.includes(item.placeholder)
  );
}

export const phoneCapableCampaigns = [
  'reminder',
  'manual',
  'lead-ads'
];

export const PHONE_CAMPAIGN_FIELDS = [
  { key: "introduction_message", label: "Introduction", manual: true },
  { key: "call_context", label: "Call Context", manual: true },
  { key: "appointment_prototype_message", label: "Appointment Info", manual: false },
  { key: "ai_transfer_message", label: "AI Enabled", manual: false, readOnly: true, aiOnly: true },
  { key: "human_pickup_message", label: "If Answered", manual: false },
  { key: "voice_mail_pickup_message", label: "If Voicemail", manual: true },
  { key: "on_opt_out_response", label: "Response to Opt Out", manual: false },
  { key: "on_confirmation_response", label: "If Confirmed", manual: false },
];

export async function getCampaignPreviewHtml(campaign) {
  switch (campaign.type) {
    case "sms": {
      const smsTemplate = campaign?.template?.sms?.template ?? "";
      return `<p>${smsTemplate}</p>`;
    }
    case "phone": {
      const phone = campaign?.template?.phone ?? {};
      const isManual = campaign?.purpose === "campaign-manual";
      const fields = PHONE_CAMPAIGN_FIELDS.filter((f) =>
        isManual ? f.manual : f.key !== "call_context"
      );
      let html = "";
      for (const field of fields) {
        if (field.aiOnly && !campaign?.settings?.ai_enabled) continue;
        const text = phone[field.key]?.text ?? "";
        if (!text) continue;
        html += `<p><strong>${field.label}:</strong><br>${text}</p><br>`;
      }
      return html || "<p>No content available</p>";
    }
    case "email": {
      if (campaign?.emailTemplate && campaign?.emailTemplate[0]) {
        return campaign.emailTemplate[0].email_content;
      }
      if (campaign?.template?.email?.email_content) {
        return campaign.template.email.email_content;
      }
      try {
        const url = campaign?.template?.email?.html_template_url;
        if (url) {
          const response = await fetch(url);
          if (response.ok) {
            return await response.text();
          }
        }
      } catch (err) {
        console.log("Template fetching failed with error", err);
      }
      return "";
    }
    default:
      return "No preview available.";
  }
}
